import { render, staticRenderFns } from "./GraphDetail56.vue?vue&type=template&id=4068502c&scoped=true"
import script from "./GraphDetail56.vue?vue&type=script&lang=js"
export * from "./GraphDetail56.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068502c",
  null
  
)

export default component.exports